export default "__VITE_ASSET__29a39588__"